// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.form_FRbUr {
  min-width: 400px;
  position : relative;
  height : 100%;
}

.content_vs7Vo {
  height : 100%;
}

.area_knyfT {
  padding : 0 var( --size-padLarge, 16px );
}

.spacer_VljgZ {
  padding-top : var( --size-padLarge, 16px );
}

.footer_eYDEA {
  padding : var( --size-padLarge, 16px );
  display : grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  column-gap: var( --size-padMedium, 8px );
}
.delete_NP3re {
  justify-self: start;
}

.saveCancel_Qjj8A {
  justify-self: end;
  display : grid;
  justify-content: center;
  align-items: stretch;
  grid-template-columns: 1fr 1fr;
  column-gap: var( --size-padMedium, 8px );

}
`, "",{"version":3,"sources":["webpack://./src/screens/role/EditModel.css"],"names":[],"mappings":";;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,wCAAwC;;AAE1C","sourcesContent":["\n\n.form {\n  min-width: 400px;\n  position : relative;\n  height : 100%;\n}\n\n.content {\n  height : 100%;\n}\n\n.area {\n  padding : 0 var( --size-padLarge, 16px );\n}\n\n.spacer {\n  padding-top : var( --size-padLarge, 16px );\n}\n\n.footer {\n  padding : var( --size-padLarge, 16px );\n  display : grid;\n  justify-content: center;\n  align-items: center;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var( --size-padMedium, 8px );\n}\n.delete {\n  justify-self: start;\n}\n\n.saveCancel {\n  justify-self: end;\n  display : grid;\n  justify-content: center;\n  align-items: stretch;\n  grid-template-columns: 1fr 1fr;\n  column-gap: var( --size-padMedium, 8px );\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `form_FRbUr`,
	"content": `content_vs7Vo`,
	"area": `area_knyfT`,
	"spacer": `spacer_VljgZ`,
	"footer": `footer_eYDEA`,
	"delete": `delete_NP3re`,
	"saveCancel": `saveCancel_Qjj8A`
};
export default ___CSS_LOADER_EXPORT___;
